export default __webpack_public_path__ + "static/media/PPI-patio-002.c8c94e21.jpg";